/**
 * @param element
 */
const openDropdown = (element) => {
    element.setAttribute('aria-expanded', 'true')
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeDropdown(element)
    })

    document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-dropdown]') && !event.target.closest('[data-dropdown-toggle]')) closeDropdown(element)
    })

    // Set the height of the inner nav container so the nav items wrap
    const navDropdownInnerContainers = document.querySelectorAll('.navDropdown__inner')
    navDropdownInnerContainers.forEach((navDropdownInner) => {
        // Grab all columns and decide the height from there
        const navDrodownColumns = navDropdownInner.querySelectorAll('.navDropdown__column')
        navDrodownColumns.forEach((navDrodownColumn) => {
            const columnHeight = navDrodownColumn.getBoundingClientRect().height
            
            // Add a class if height is greater than 300 (could change this number, that was a guess)
            if (columnHeight > 300) {
                navDrodownColumn.classList.add('navDropdown__column--tall')
            }
        })
    })
}

/**
 * @param element
 */
const closeDropdown = (element) => {
    element.setAttribute('aria-expanded', 'false')
}

const closeAllDropdowns = () => {
    document.querySelectorAll('[data-dropdown-toggle]').forEach(element => closeDropdown(element))
}

document.querySelectorAll('[data-dropdown-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
        event.preventDefault()
        if (toggle.getAttribute('aria-expanded') === 'false') {
            closeAllDropdowns()
            openDropdown(toggle)
            return
        }

        closeDropdown(toggle)
    })
})
